import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  private http = inject(HttpClient);

  get(): Observable<any[]> {
    return this.http.get<any[]>(Global.url + 'V1/process-ref');
  }

  create(data: any): Observable<any> {
    return this.http.post(Global.url + 'V1/process-ref', data);
  }

  // Actualiza proceso por su UUID
  update(uuid: string, data: any): Observable<any> {
    return this.http.put(Global.url + 'V1/process-ref/' + uuid, data);
  }

  // Elimina proceso por su UUID
  delete(uuid: string): Observable<any> {
    return this.http.delete(Global.url + 'V1/process-ref/' + uuid);
  }
}
